import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { MyUserTask } from './my-user-task';
export { MyUserTask };
import { myUserTaskSchema } from '@schemas/business-objects/my-user-task';
import { RoleFormGroup } from './role-form-group';
import { TokenFormGroup } from './token-form-group';
import { UserFormGroup } from './user-form-group';

export class MyUserTaskFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    userTaskId: SchemaFormControl;
    referenceNumber: SchemaFormControl;
    name: SchemaFormControl;
    status: SchemaFormControl;
    data: SchemaFormControl;
    completedAt: SchemaFormControl;
    candidateUserId: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    roleId: SchemaFormControl;
    role: RoleFormGroup;
    userId: SchemaFormControl;
    user: UserFormGroup;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
  };

  declare value: Partial<MyUserTask>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(myUserTaskSchema, MyUserTask, data, options);
  }

  get object(): MyUserTask {
    return new MyUserTask(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'role':
        return new RoleFormGroup();
      case 'user':
        return new UserFormGroup();
      case 'token':
        return new TokenFormGroup();
      default:
        return undefined;
    }
  }
}

export class MyUserTaskFormArray extends PersistedFormArray {
  readonly entityName = 'MyUserTask' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(myUserTaskSchema, MyUserTask, options);
  }

  protected override createItemGroup() {
    return new MyUserTaskFormGroup();
  }

  get array(): MyUserTask[] {
    return this.controls.map((group: MyUserTaskFormGroup) => group.object);
  }
}

export class MyUserTaskPersistedArray extends PersistedArray<MyUserTask> {
  readonly entityName = 'MyUserTask' as const;

  constructor(options?: PersistedArrayOptions) {
    super(MyUserTask, options);
  }
}
